module.exports = __webpack_public_path__ + "img/messages_no_results.8c10e79.png";